const POEditPage = () => <></>;

export default POEditPage;
